<template>
  <div>
    <!-- Title -->
    <div class="d-flex justify-between mb_35 align-center">
      <p class="title">Avaliação</p>
      <div
        v-if="!!ratingData && !!ratingData.rating_average"
        :class="{
          'd-flex': true,
          'text-right': true,
          'order-average': true,
          negative: ratingData.rating_average && ratingData.rating_average <= 2,
        }"
      >
        <p>{{ getFormattedAverage(ratingData.rating_average) }}</p>
        <i
          :class="{
            fas: !!Number.isInteger(ratingData.rating_average),
            fad: !Number.isInteger(ratingData.rating_average),
            'fa-star': true,
            'fa-star-half': !Number.isInteger(ratingData.rating_average),
          }"
        ></i>
      </div>
    </div>

    <span v-if="!ratingData || !ratingData.rating_average" class="empty">
      Pedido ainda não recebeu avaliação
    </span>

    <!-- Colapse -->
    <div
      v-if="!!ratingData && !!ratingData.rating_average"
      v-for="(category, indexCategory) in categoryRating"
      :key="indexCategory"
      class="align-start justify-between mb_15 mt_20"
    >
      <div class="d-flex mb_20 justify-between rating-category">
        <p>{{ category.label }}</p>
        <div class="d-flex align-center colapse-rating-tags">
          <star-rating
            :rating="
              ratingData.answer.find((a) => a.id_question == indexCategory + 1)
                .value
            "
            size="1.2em"
          />
          <i
            :class="{
              fas: true,
              'fa-chevron-right': !category.open,
              'fa-chevron-down': category.open,
              'cursor-pointer': true,
            }"
            @click="category.open = !category.open"
          ></i>
        </div>
      </div>
      <div
        class="d-flex align-start justify-start mb_15 flex-wrap"
        v-if="category.open"
      >
        <div
          v-if="
            !!ratingData.answer.find((a) => a.id_question == indexCategory + 1)
              .tags.length
          "
        >
          <span
            v-for="(itemCategory, indexItem) in ratingData.answer.find(
              (a) => a.id_question == indexCategory + 1
            ).tags"
            :key="indexItem"
            class="category-rating-item"
            >{{ getTagLabel(itemCategory) }}</span
          >
        </div>
        <p v-else class="mb_5 mt_5 category-empty">
          Este quesito da avaliação não foi detalhado.
        </p>
      </div>
      <hr class="line" />
    </div>

    <!-- Comment -->
    <div
      class="align-start justify-between rating-comment"
      v-if="!!ratingData && !!ratingData.rating_average"
    >
      <p class="mb_20">Comentário</p>
      <div>
        <p v-if="ratingData.answer.find((a) => a.id_question == 4)" class="p_15">
          "{{
            (
              ratingData.answer.find((a) => a.id_question == 4) || {
                comment: "",
              }
            ).comment
          }}"
        </p>
        <p v-else>
          Não há comentários neste pedido.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import StarRating from "@/components/StarRating";
import SurveyAPI from "@/api/survey";
import ApiReports from "@/api/reports";

export default {
  props: {
    id: { required: true },
  },
  data() {
    return {
      categoryRating: [
        { label: "Atendimento", open: false },
        { label: "Pedido", open: false },
        { label: "Entrega", open: false },
      ],
      aSurvey: {},
      tags: [],
      ratingData: {},
    };
  },
  components: {
    StarRating,
  },
  methods: {
    getFormattedAverage(value) {
      return value ? value.toFixed(1).replace(".", ",") : 0;
    },
    getTagLabel(id) {
      const item = this.tags.find((tag) => tag.id == id);
      return !!item ? item.label["pt-br"] : "";
    },
  },
  created() {
    const esDataFilter = {
      query: [
        {
          index: "report-rating-orders",
          type: "query",
          queries: [
            {
              query_string: {
                query: `*${this.id}*`,
                fields: ["order_id"],
              },
            },
          ],
        },
      ],
    };
    ApiReports.reports(esDataFilter).then((response) => {
      if (response.data && response.data[0]) {
        response.data[0].hits.forEach((item) => {
          this.ratingData = item._source;
        });
      }
    });
    SurveyAPI.GetSurvey().then((response) => {
      this.aSurvey = response.getData({ questions: [] });
      this.tags = this.aSurvey.questions
        .filter((a) => a.type == "RATING")
        .map((a) => a.configs.map((z) => z.tags).flat())
        .flat();
    });
  },
};
</script>
<style scoped>
.empty {
  font-size: 1.2em;
  color: #a0a0a0;
}
.title {
  font-size: 1.4em;
  color: #C9C9C9C7;
  font-weight: bold;
}
.order-average {
  color: #FFB366;
  align-items: center;
}
.order-average > p {
  font-size: 1.4em;
  font-weight: bold;
}
.order-average > i {
  font-size: 1.2em;
  margin-left: 5px;
}
.order-average.negative {
  color: #e25569;
}
.rating-category {
  align-items: baseline;
}
.rating-category > p {
  color: #999999;
  font-size: 1.2em;
}
.category-rating-item {
  width: max-content;
  background: var(--box-up);
  border-radius: 5px;
  font-size: 1.2em;
  color: #999;
  padding: 5px 20px;
  margin-right: 5px;
  margin-bottom: 5px;
}
.line {
  border: none;
  border-top: 1px solid #FFF;
  opacity: 0.1;
  margin: 15px 0;
}
.rating-comment {
  font-size: 1.4em;
  font-weight: bold;
  color: #999999;
}
.rating-comment > div {
  font-weight: 500;
  color: #999999;
  font-size: 12px;
}
.colapse-rating-tags > div {
  margin-right: 30px;
}
.colapse-rating-tags > i {
  color: #999999;
  font-size: 1em;
  margin-left: 2em;
  position: absolute;
  right: 0;
}
.category-empty {
  font-size: 1.2em;
  color: #999999;
}
</style>